import { createAsyncThunk } from '@reduxjs/toolkit'
import railsApiService from 'services/api/rails-api-service'

interface GeneratePixCodeParams {
  number: string
}

export const generatePixCode = createAsyncThunk(
  'generate-pix-code',
  async (params: GeneratePixCodeParams, { rejectWithValue }) => {
    try {
      const { data } = await railsApiService.apiInstance.post<{
        qrcode: string
      }>('/api/v2/storefront/pix_payment/generate_code', params)

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
